<template>
  <div class="receipt-page">
    <van-nav-bar title="收款信息" left-arrow left-text="返回" @click-left="$router.push('/mine')" />
    <van-loading v-if="loading" />
    <template v-else-if="loaded">
      <div v-for="kind in ['wechat', 'alipay']" :key="kind">
        <receipt-form :ref="kind" :kind="kind" :saved="receipts.find(r => r.kind === kind) || null" />
        <van-button v-if="!receipts.some(r => r.kind === kind)" block type="primary" :loading="saving" @click="save(kind)">确认补填{{ kind === 'wechat' ? '微信' : '支付宝' }}收款信息</van-button>
      </div>
    </template>
    <van-button v-else block @click="load">加载失败，点击重试</van-button>
  </div>
</template>
<script>
import ReceiptForm from '@/components/ReceiptForm.vue';
import { receiptRequest } from '@/api-service/receipt';
export default {
  components: { ReceiptForm },
  data() { return { receipts: [], loading: false, loaded: false, saving: false }; },
  created() { this.load(); },
  methods: {
    async load() { this.loading = true; try { const res = await receiptRequest('/api/receipt/list'); this.receipts = res.list || []; this.loaded = true; } catch (e) { this.$toast.fail(e.message); } finally { this.loading = false; } },
    async save(kind) {
      if (this.saving) return;
      try {
        const value = this.$refs[kind][0].value();
        if (!value) throw new Error('请先填写收款信息');
        await this.$dialog.confirm({ title: '确认收款信息', message: `收款人：${value.name}\n使用上传的收款码\n提交后仅管理员可修改，请核对。` });
        this.saving = true;
        await receiptRequest('/api/receipt/add', value); this.$toast.success('已保存'); await this.load();
      } catch (e) { if (e && e.message) this.$toast.fail(e.message); } finally { this.saving = false; }
    }
  }
};
</script>
<style scoped>.receipt-page { min-height: 100vh; background: #f7f8fa; padding: 0 12px 24px; }</style>
